import { render, staticRenderFns } from "./menuOptions.vue?vue&type=template&id=080e7b31&scoped=true"
import script from "./menuOptions.vue?vue&type=script&lang=js"
export * from "./menuOptions.vue?vue&type=script&lang=js"
import style0 from "./menuOptions.vue?vue&type=style&index=0&id=080e7b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e7b31",
  null
  
)

export default component.exports